export default {
  isFetchedToEnd(state) {
    if (state.articles.length > 0) {
      // if have articles in store
      // check if the new fetched articles are empty or not
      if (state.articles[state.articles.length - 1].post_id == null) {
        return true;
      }
      return false;
    }
    return true;
  },
};
